module.exports = "<div class=\"item\">\r\n    <slot></slot>\r\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
 ** module id = 199
 ** module chunks = 0
 **/